<template>
  <v-dialog content-class="max-wrap" v-model="show" width="470" persistent>
    <v-card>
      <v-card-title class="headline" primary-title>
        <div class="ml-auto cursor" @click="close()">
          <v-icon>mdi-close</v-icon>
        </div>
      </v-card-title>
      <v-card-text>
        <div class="fontStyle">
          <div class="imgStyle">
            <img :src="titleImg" width="80" height="80" />
          </div>
          <div class="row">
            <div class="col-12 text-center Enlarge mt-2">{{ $t('registerSuccessfulModel.title') }}</div>
            <p class="col-12 text-center mb-0 px-3 py-1" v-html="$t('registerSuccessfulModel.desc')"></p>
          </div>
          <div>
            <div class="btnstyl">
              <a v-for="(value, name, index) in btnList" :href="value.path" target="_blank" :key="index" style="margin-right:6px">
                <img :src="value.icon" height="50" alt />
              </a>
            </div>
          </div>
          <div class="row">
            <p class="col-12 text-center descstyle px-3 py-0 mt-2">{{ $t('promoMaxRegModal.unableDownload') }}</p>
            <p
              class="col-12 text-center px-3 py-0 mb-0"
              v-html="
                $t('promoMaxRegModal.downloadLink')
                  .replace('{ios}', grxIpa)
                  .replace('{android}', grxApk)
              "
            ></p>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      titleImg: require('@/assets/images/account/grx_app_logo@2x.png'),
      btnList: {
        grx_ios_store: {
          icon: require('@/assets/images/home/grx_ios_store.svg'),
          path: ''
        },
        grx_android_store: {
          icon: require('@/assets/images/home/grx_android_store.svg'),
          path: ''
        }
      },
      grxIpa: '',
      grxApk: ''
    };
  },
  props: {
    title: {
      type: String,
      default: ' '
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    assignEnvConfig() {
      this.btnList['grx_ios_store'].path = 'https://apps.apple.com/us/app/grxtrade/id1495956494?ls=1';
      this.btnList['grx_android_store'].path = 'https://play.google.com/store/apps/details?id=com.grxtrade.app';
      this.grxIpa = window.env.grxApp.ipa;
      this.grxApk = window.env.grxApp.apk;
    },
    close() {
      this.$emit('update:show', false);
    }
  },
  mounted() {
    this.assignEnvConfig();
  }
};
</script>
<style lang="stylus" scoped>
@import '../../../../components/MaxRegisterModal/max-register-modal.styl';
.btnstyl {
  margin-top: 10px;
  justify-content: center;
  display: flex;
  flex-direction: row;
}

.fontStyle {
  font: Light 24px / 33px Open Sans;
  color: #555555;

  .Enlarge {
    font-size: 1.5rem;
  }

  a {
    color: #1E49AC;
  }
}
.imgStyle {
  display :flex;
  justify-content :center;
}

.descstyle {
  margin-bottom: 0px;
}

@media screen and (max-width: 450px) {
  .btnstyl img {
    width:141px;
  }
}
</style>
